<template>
  <w-radio-list class="mt-3" :model="schema.replyByEpuap" :values="replyByEpuapValues" />
</template>

<script>
import { formMixin } from '@/mixins/form';

// @vuese
// Wybór formy odpowiedzi
// @group ActionData
export default {
  mixins: [formMixin],
  props: {
    // schema akcji
    schema: { type: Object, required: true }
  },
  data() {
    return {
      replyByEpuapValues: [
        { value: true, text: 'w postaci elektronicznej' },
        { value: false, text: 'w postaci papierowej' }
      ]
    };
  }
};
</script>
